import {Component, Input, OnInit} from '@angular/core';
import {BlacklistRemarkModel} from '../../../../shared/dto/blacklist-remark.model';

@Component({
  selector: 'app-remark-details',
  templateUrl: './remark-details.component.html',
  styleUrls: ['./remark-details.component.scss']
})
export class RemarkDetailsComponent implements OnInit {
  @Input() data: BlacklistRemarkModel[];
  @Input() dataEXM: BlacklistRemarkModel[];
  @Input() dataDG: BlacklistRemarkModel[];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;
  constructor() { }

  ngOnInit() {
  }

}
